import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize, catchError, of as observableOf } from 'rxjs';
import { PatientRegistrationService } from 'src/app/pages/patient-registration/patient-registration.service';
import { DialogService } from '../dialog.service';
import { LanguageService } from '../../language/language.service';
import { environment } from "src/environments/environment";
import * as _ from 'lodash';

@Component({
  selector: 'esc-coupon-entry-dialog',
  templateUrl: './coupon-entry-dialog.component.html',
  styleUrls: ['./coupon-entry-dialog.component.scss']
})
export class CouponEntryDialogComponent implements OnInit {

  public couponForm: FormGroup;
  public isSubmitting: boolean = false;
  public errorMessage: String;

  constructor(
    public dialogRef: MatDialogRef<CouponEntryDialogComponent>,
    private fb: FormBuilder,
    private patientRegistrationService: PatientRegistrationService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.couponForm = this.fb.group({
      coupon: [null, Validators.required],
    });
  }

  onSubmit(value: any) {
    this.isSubmitting = true;
    this.couponForm.disable();

    this.patientRegistrationService.addCoupon({ data: {
      email: this.data.email, 
      // uuid: localStorage.getItem('md-uuid'),
      uuid: this.data.uuid,
      ...value }
     }).pipe(
      finalize(() => {
        this.isSubmitting = false
        this.couponForm.enable();
      })
    ).subscribe((res: any) => {
      console.log(res)
      if (environment.showLogs) {
        console.log(res);
      }

      if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}))
        return;
      }
      
      if (_.get(res, 'success.count') > 0) {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_COUPON_ACTIVATED", {}))
        this.dialogRef.close(true);
      } else {
        this.errorMessage = this.languageService.getTranslation("MSG_ERROR_COUPON_INVALID", {})
      }
    }, err => {
      if (environment.showLogs) {
        console.error(err);
      }

      console.log(err)
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
      return observableOf(null);
    })

    // // for demo purposes
    // var valid = true;
    // if (value.coupon.startsWith('10')) {
    //   this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_COUPON_INVALID", {}))
    //   valid = false
    // } else if (value.coupon.startsWith('11')) {
    //   this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_COUPON_ACTIVATED", {}))
    //   valid = false
    // } else {
    //   this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_COUPON_ACTIVATED", {}))
    // }

    // this.isSubmitting = false;
    // this.couponForm.enable();
    // if (valid) this.dialogRef.close(true)
  }

}
